// extracted by mini-css-extract-plugin
export default {"dropdown":"b4sQmnw044mRYyCv7Pjc"};